import React from 'react';
import { StyledButton, Title } from './ButtonMedium.styled';

export interface IButton {
    title: string;
    onClick: () => void;
}

export function ButtonMedium ({title, onClick}: IButton) {

  return (
    <StyledButton
      onClick={onClick}
    >
          <Title>{title}</Title>
    </StyledButton>
  );
}
